import {
  BULK_USER_UPLOAD,
  BULK_USER_UPLOAD_ALLOWED_FORMAT,
  BULK_USER_UPLOAD_FAILED_MESSAGE,
  BULK_USER_UPLOAD_FILE_FORMAT_ERROR,
} from "../common/Constants";
import {bulkUploadSkippedDetail} from "../models/user";
import {MessageHandlerService} from "../services/message-handler.service";
import {ProgressBarService} from "../services/progress-bar.service";
import {UserService} from "../services/user.service";

/** What a users page lends the bulk user upload: its services, and how to clear its file picker and reload its list. */
export interface BulkUserUploadPage {
  userService: UserService;
  progressBarService: ProgressBarService;
  messageHandlerService: MessageHandlerService;
  clearFile: () => void;
  reloadUsers: () => void;
}

/** The bulk user upload of the IOH and agency users pages, which used to carry a copy each (IOHB-2145). */
export function uploadBulkUsers(event: {files: File[]}, page: BulkUserUploadPage): void {
  page.progressBarService.setProgressBarVisibility(true);
  const file = event.files[0];
  if (file.type !== BULK_USER_UPLOAD_ALLOWED_FORMAT) {
    page.clearFile();
    page.progressBarService.setProgressBarVisibility(false);
    page.messageHandlerService.generateToastMessage("error", "", BULK_USER_UPLOAD_FILE_FORMAT_ERROR);
    return;
  }
  const formData = new FormData();
  formData.append("file", file);
  page.userService.bulkUpload(formData).subscribe((res) => {
    if (res && res.success) {
      page.progressBarService.setProgressBarVisibility(false);
      page.reloadUsers();
      // IOHB-2145: the upload lists the rows it didn't save; show them until closed.
      if (res.skipped?.length) {
        page.messageHandlerService.generateToastMessage("warn", res.message, bulkUploadSkippedDetail(res.skipped), true);
      } else {
        page.messageHandlerService.generateToastMessage("success", "", BULK_USER_UPLOAD);
      }
      page.clearFile();
    } else {
      page.clearFile();
      // IOHB-2145: the upload says why it failed, for example "Invalid CSV file".
      const errorMessage = res?.message || res?.errorMessage || BULK_USER_UPLOAD_FAILED_MESSAGE;

      page.progressBarService.setProgressBarVisibility(false);
      page.messageHandlerService.generateToastMessage("error", "", errorMessage);
    }
  });
}
